import type {DocsetManifest} from '../types/docset';

export function ensureTrailingSlash(value: string): string {
  return value.endsWith('/') ? value : `${value}/`;
}

function ensureLeadingSlash(value: string): string {
  return value.startsWith('/') ? value : `/${value}`;
}

function computeBasePath(manifest: DocsetManifest): string {
  const base = manifest.basePath ?? '';
  if (base.startsWith('http://') || base.startsWith('https://')) {
    return ensureTrailingSlash(base);
  }
  if (base.startsWith('/')) {
    return ensureTrailingSlash(base);
  }
  const slug = (manifest.id ?? '').replace(/^\/+|\/+$/g, '');
  return slug ? `/${slug}/` : '/';
}

export function resolveResource(manifest: DocsetManifest, resource: string): string {
  if (!resource) {
    return computeBasePath(manifest);
  }
  if (/^https?:\/\//.test(resource)) {
    return resource;
  }
  const trimmed = resource.replace(/^\/+/, '');
  const base = computeBasePath(manifest);
  if (base.startsWith('http://') || base.startsWith('https://')) {
    return new URL(trimmed, base).toString();
  }
  const normalized = ensureLeadingSlash(ensureTrailingSlash(base));
  return `${normalized}${trimmed}`.replace(/\/{2,}/g, '/').replace(':/', '://');
}
